import type { ConsumerConfig } from '../index';
import logo from './logo.svg';

/**
 * Wynn Las Vegas consumer configuration.
 * Everything for Wynn lives in this folder — logo, theme, config.
 *
 * Cannot import from idme-assets directly: it is a Rails gem with no npm exports.
 * All values below are sourced from:
 *   idme-assets/app/assets/stylesheets/themes/wynn/_colors.scss
 *   idme-assets/app/assets/stylesheets/themes/wynn/_base.scss
 *
 * CSS overrides live in wynn/theme.scss (--consumer-* vars under .theme-wynn).
 *
 * Font note: "Avenir" is a system font on macOS/iOS. Falls back to sans-serif
 * on other platforms. No font file needed — zero extra load.
 */
export const wynnConfig: ConsumerConfig = {
  themeClass: 'theme-wynn',
  logo: {
    src: logo,
    alt: 'Wynn Las Vegas',
  },
  brand: {
    fontFamily: '"Avenir", sans-serif',  // $avenir in _base.scss
    colorPrimary: '#2E6D62',             // $action in _colors.scss
    colorTextPrimary: '#3C3C3C',         // $primary in _colors.scss
    colorTextSecondary: '#626262',       // $secondary in _colors.scss
  },
};
